import { variants } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import ImportantInformationNotification from './ImportantInformationNotification';

const ImportantInformation = () => {
  const { t } = useTranslation();
  const { p } = useProperty();

  const showInformationBox = p('IbeClient.InformationBox.Show');
  const showWarningBox = p('IbeClient.WarningBox.Show');
  const showCriticalBox = p('IbeClient.CriticalBox.Show');

  return (
    <>
      {showInformationBox && (
        <ImportantInformationNotification
          content={t('IbeClient.InformationBox.Content.Text')}
          id="important-information-info"
          title={t('IbeClient.InformationBox.Header.Text')}
          variant={variants.INFORMATION}
        />
      )}
      {showWarningBox && (
        <ImportantInformationNotification
          content={t('IbeClient.WarningBox.Content.Text')}
          id="important-information-warning"
          title={t('IbeClient.WarningBox.Header.Text')}
          variant={variants.WARNING}
        />
      )}
      {showCriticalBox && (
        <ImportantInformationNotification
          content={t('IbeClient.CriticalBox.Content.Text')}
          id="important-information-critical"
          title={t('IbeClient.CriticalBox.Header.Text')}
          variant={variants.CRITICAL}
        />
      )}
    </>
  );
};

export default ImportantInformation;
